import { render, staticRenderFns } from "./SithMesInventoryPackageMaterialList.vue?vue&type=template&id=c56d3eb0&"
import script from "./SithMesInventoryPackageMaterialList.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryPackageMaterialList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports